import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnterpriseSettingsDto } from '../interfaces/enterprise-settings-dto';
import { Observable } from 'rxjs';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class EnterpriseSettingsService {
    private http = inject(HttpClient);
    private env = inject(envToken);


    getEnterpriseSettingsPolicyUrl = '';
    saveEnterpriseSettingsPolicyUrl = '';

    constructor() {
        this.getEnterpriseSettingsPolicyUrl = this.env.apiUrl + '/api/v1/enterprise-settings/enterprise';
        this.saveEnterpriseSettingsPolicyUrl = this.env.apiUrl + '/api/v1/policy/enterprise-settings/enterprise';
    }

    getEnterpriseSettingsPolicy(id: number): Observable<EnterpriseSettingsDto> {
        return this.http.get<EnterpriseSettingsDto>(`${this.getEnterpriseSettingsPolicyUrl}/${id}`);
    }

    saveEnterpriseSettingsPolicy(id: number, model: EnterpriseSettingsDto): Observable<EnterpriseSettingsDto> {
        return this.http.post<EnterpriseSettingsDto>(`${this.saveEnterpriseSettingsPolicyUrl}/${id}`, model);
    }

}
